export const initialStateTripsByDate = {
    trips: [],
    loading: false,
    errorMessage: null,
};

export const TripsByDateReducer = (state = initialStateTripsByDate, action) => {
    switch (action.type) {
        case 'REQUEST_TRIPS_BY_DATE': {
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };
        }
        case 'FETCH_TRIPS_BY_DATE_SUCCESS': {
            return {
                ...state,
                trips: action.payload,
                loading: false,
            };
        }
        case 'FETCH_TRIPS_BY_DATE_ERROR': {
            return {
                ...state,
                errorMessage: action.error,
                loading: false,
            };
        }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
